/**
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { c as createSVGComponent } from '../utils-9450cd75.js';
import '@carbon/icon-helpers';
import 'vue';

const TextAlignLeft20 = createSVGComponent('TextAlignLeft20', {
  "xmlns": "http://www.w3.org/2000/svg",
  "viewBox": "0 0 32 32",
  "fill": "currentColor",
  "width": 20,
  "height": 20
}, [{
  "elem": "path",
  "attrs": {
    "d": "M12 6H26V8H12zM12 12H22V14H12zM12 18H26V20H12zM12 24H22V26H12zM6 4H8V28H6z"
  }
}]);

export { TextAlignLeft20 as default };
